import yup from '../../../translations/yup/yupLocale';

const validationSchema = yup.object({
  username: yup.string().min(3).required().label('Login/Email'),
});

export default validationSchema;
